import { useEffect, useState } from 'react';

const useLastNonNullValue = <T>(value: T | undefined | null, startValue: T): T => {
    const [lastNonNull, setLastNonNull] = useState<T>(startValue);

    useEffect(() => {
        if (value !== null && value !== undefined) {
            setLastNonNull(value);
        }
    }, [value]);

    return lastNonNull;
};

export default useLastNonNullValue;
